// extracted by mini-css-extract-plugin
module.exports = {"PostTemplate":"PostTemplate-module--PostTemplate--gkv4q","Content":"PostTemplate-module--Content--P67hV"};